import type { Story } from '@/@types/story'
import { markStoryFeedUserReadInCache, readStory } from '@/utils/fetchers/story'
import queryClient from '@/utils/queryClient'
import { useEffect } from 'react'

interface UseStoryReadReceiptOptions {
	active: boolean
	story?: Story
	readStories: Set<string>
}

export default function useStoryReadReceipt({
	active,
	story,
	readStories,
}: UseStoryReadReceiptOptions) {
	useEffect(() => {
		if (!active || !story || readStories.has(story.id)) return

		readStories.add(story.id)
		void readStory(story.id)
			.then(() => markStoryFeedUserReadInCache(queryClient, story.user.username))
			.catch(() => readStories.delete(story.id))
	}, [active, readStories, story])
}
